import FontSettings from './FontSettings';

export default FontSettings;
